var _rect, _rect2, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactIco1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 49,
    height: 49,
    rx: 6.5,
    fill: "black",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 6.5,
    fill: "#FFFB9E",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 15.625H13.75C13.2527 15.625 12.7758 15.8225 12.4242 16.1742C12.0725 16.5258 11.875 17.0027 11.875 17.5V32.5C11.875 32.9973 12.0725 33.4742 12.4242 33.8258C12.7758 34.1775 13.2527 34.375 13.75 34.375H36.25C36.7473 34.375 37.2242 34.1775 37.5758 33.8258C37.9275 33.4742 38.125 32.9973 38.125 32.5V17.5C38.125 17.0027 37.9275 16.5258 37.5758 16.1742C37.2242 15.8225 36.7473 15.625 36.25 15.625V15.625ZM34.1875 17.5L25 23.8562L15.8125 17.5H34.1875ZM13.75 32.5V18.3531L24.4656 25.7687C24.6226 25.8776 24.809 25.936 25 25.936C25.191 25.936 25.3774 25.8776 25.5344 25.7687L36.25 18.3531V32.5H13.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIco1);
export default __webpack_public_path__ + "static/media/contact_ico1.27c60b1837d57ad6b34896d570770a2a.svg";
export { ForwardRef as ReactComponent };